import { render, staticRenderFns } from "./MyOrderAdd.vue?vue&type=template&id=1007203c&scoped=true&"
import script from "./MyOrderAdd.vue?vue&type=script&lang=ts&"
export * from "./MyOrderAdd.vue?vue&type=script&lang=ts&"
import style0 from "./MyOrderAdd.vue?vue&type=style&index=0&id=1007203c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007203c",
  null
  
)

export default component.exports